import CustomButton from "atoms/customButton/CustomButton";
import ApiKeyTab from "component/apiKeyTab/ApiKeyTab";
import CustomDialog from "component/CustomDialog";
import CustomTableMui from "component/customTableMui/CustomTableMui";
import { API_KEY_HEADER } from "component/customTableMui/tableData";
import LoadingScreen from "component/LoadingScreen";
import RegisterKey from "component/registerKey/RegisterKey";
import ShowApiKey from "component/showApiKey/ShowApiKey";
import WarningModal from "component/warningModal/WarningModal";
import { TOAST_TYPES } from "enum/enums";
import { MUI_TABLE_TYPE } from "lib/Constants";
import { copyToClipboard, handleErrorMessage } from "lib/utils";
import { Plus } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import organization from "services/organizationService";
import { RootState } from "store/store";
import { addToast } from "store/toaster/reducer";

const ApiKeyCreate = () => {
	const [loading, setLoading] = useState(true);
	const [apiKeys, setApiKeys] = useState<Record<string, any>[]>([]);
	const [showModal, setShowModal] = useState(false);
	const { selectedTenant } = useSelector((store: RootState) => store.auth);
	const [apiKey, setApiKey] = useState<Record<string, any>>();
	const [modalTypes, setModalTypes] = React.useState<"register" | "delete">("register");
	const apiKeyHashRef = React.useRef<string>("");
	const [deleteLoading, setDeleteLoading] = useState(false);

	const dispatch = useDispatch();
	const handleShowModal = () => {
		setShowModal(!showModal);
	};

	const getRegistered = async (tenantName: string,apiKeyType:string) => {
		try {
			const res = await organization.generateNewApiKey({ id: selectedTenant?.tenantId ?? "", apiKeyName: tenantName,apiKeyType });
			setApiKey(res?.data);
			getApikeys(false);
		} catch (error) {
			console.log(error, "error");
			throw error;
		}
	};
	const handleCopy = async () => {
		try {
			await copyToClipboard(apiKey?.apiKey);
		} catch (error) {
			console.log(error);
		}
	};

	const getApikeys = async (noLoading = true) => {
		if (noLoading) {
			setLoading(true);
		}
		try {
			const res = await organization.getListApiKey(selectedTenant?.tenantId ?? "");
			setApiKeys(res?.data?.apiKeys);
		} catch (error) {
			dispatch(addToast({ type: TOAST_TYPES.ERROR, message: handleErrorMessage(error) }));
		} finally {
			setLoading(false);
		}
	};
	const deleteApiKey = async () => {
		setDeleteLoading(true);
		try {
			
			const res = await organization.deleteApiKey({ id: selectedTenant?.tenantId, apiKeyHash: apiKeyHashRef.current });
			const filteredApiKeys = apiKeys.filter((el) => el?.apiKeyHash !== apiKeyHashRef.current);
			setApiKeys([...filteredApiKeys]);
			console.log(res?.data);
			handleShowModal();
		} catch (error) {
			dispatch(addToast({ type: TOAST_TYPES.ERROR, message: handleErrorMessage(error) }));
		}finally{
			setDeleteLoading(false);
		}
	};
	const handleApiKeyDelete = async (apiKeyHash: string | number) => {
		apiKeyHashRef.current = String(apiKeyHash);
		setModalTypes("delete")
		handleShowModal();
	}

	useEffect(() => {
		// handleShowModal();
		getApikeys();
	}, [selectedTenant]);

	return (
		<>
			{loading ? (
				<div className="flex align-center min-h-250 justify-center h-full">
					<LoadingScreen height={false} />
				</div>
			) : (
				<>
					{apiKeys?.length > 0 ? (
						<div>
							{/* table */}
							<ApiKeyTab
								showOverview={false}
								title="User API Keys"
								description="An API key lets you connect to our API and use its features. You can create multiple keys with different access levels."
							>
								<CustomButton
									className="sm"
									handleFunc={() => {
										handleShowModal();
										setModalTypes("register");
										setApiKey(undefined);
									}}
									buttonIcon={<Plus />}
									buttonText="Create Key"
								/>
							</ApiKeyTab>
							<div className="apiKeyTable">
								<CustomTableMui handleRemoveRow={handleApiKeyDelete} columns={API_KEY_HEADER} rows={apiKeys || []} type={MUI_TABLE_TYPE.API_KEY} />
							</div>
						</div>
					) : (
						<>
							<ApiKeyTab title="User API Keys" description="An API key lets you connect to our API and use its features. You can create multiple keys with different access levels.">
								<CustomButton className="sm" handleFunc={()=>{
									handleShowModal();
										setModalTypes("register");
										setApiKey(undefined);
								}} buttonIcon={<Plus />} buttonText="Create Key" />
							</ApiKeyTab>
						</>
					)}
				</>
			)}
			<CustomDialog  open={showModal} handleShowModal={handleShowModal}>
				{apiKey ? (
					<ShowApiKey
						handleCopy={handleCopy}
						apiKey={apiKey?.apiKey}
						handleShowModal={() => {
							handleShowModal();
							setApiKey(undefined);
						}}
						heading={`API Key - ${apiKey?.apiKeyName}`}
						subheading="This is your new API key. Make sure to copy it before closing this dialog as it will not be displayed again!"
					/>
				) : modalTypes === "register" ? (
					<RegisterKey getRegistered={getRegistered} handleShowModal={handleShowModal} />
				) : (
					<WarningModal
						message="Do you really want to delete this ApiKey? This action is irreversible."
						title="Delete ApiKey"
						onClose={handleShowModal}
						onConfirm={() => deleteApiKey() }
						loading={deleteLoading}
					/>
				)}
			</CustomDialog>
		</>
	);
};

export default ApiKeyCreate;
